"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fixSesame = fixSesame;
var _fetch = _interopRequireDefault(require("@/utils/fetch"));
/**
 * 订单修复处理
 */

// 处理芝麻信用
function fixSesame(params) {
  return _fetch.default.post("/Supplier/OrderHandle/handleNew", params);
}